var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('fei-shu-document-new',{attrs:{"token":_vm.documentToken}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }